import { render, staticRenderFns } from "./JourneyChapters.vue?vue&type=template&id=14a891d6&scoped=true"
import script from "./JourneyChapters.vue?vue&type=script&lang=js"
export * from "./JourneyChapters.vue?vue&type=script&lang=js"
import style0 from "./JourneyChapters.vue?vue&type=style&index=0&id=14a891d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a891d6",
  null
  
)

export default component.exports